import { createStore, applyMiddleware,compose } from 'redux';
import thunk from 'redux-thunk';
import { createLogger } from 'redux-logger';
//import createRootReducer from '../reducers';
import rootReducer from '../reducers';
import { history } from '../helpers';
import { routerMiddleware } from 'connected-react-router';


const loggerMiddleware = createLogger();

const composeEnhancer = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const store = createStore(
  rootReducer,
  composeEnhancer(
    applyMiddleware(
      loggerMiddleware,
      thunk,
      routerMiddleware(history),
    ),
  ),
);